import axiosVendorInstance from './axiosVendorInstance';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export async function getOpenStatusFromAPI(vendorId) {
    try {
        const response = await axiosVendorInstance.get(`/business-hours/vendor/${vendorId}`);
        const businessHours = response?.data?.business_hours;
        const vendorTimezone = response?.data?.timezone;

        if (!businessHours || !vendorTimezone) {
            console.log('No business hours or timezone available');
            return { status: 'closed', nextOpenTime: null, nextOpenDay: null };
        }

        const now = dayjs.utc().tz(vendorTimezone);
        const currentDay = now.format('dddd');
        const todaySchedule = businessHours.find(bh => bh.day.toLowerCase() === currentDay.toLowerCase());

        let isOpen = false;
        let nextOpenTime = null;
        let nextOpenDay = null;

        // Check today's intervals
        if (todaySchedule?.is_open && Array.isArray(todaySchedule.intervals)) {
            for (let interval of todaySchedule.intervals) {
                const dateStr = now.format('YYYY-MM-DD');
                const open = dayjs.tz(`${dateStr} ${interval.open_time}`, 'YYYY-MM-DD HH:mm', vendorTimezone);
                let close = dayjs.tz(`${dateStr} ${interval.close_time}`, 'YYYY-MM-DD HH:mm', vendorTimezone);

                if (close.isBefore(open)) {
                    close = close.add(1, 'day');
                }

                if (now.isAfter(open) && now.isBefore(close)) {
                    isOpen = true;
                    break;
                }

                if (!isOpen && now.isBefore(open) && !nextOpenTime) {
                    nextOpenTime = open.format('hh:mm A');
                    nextOpenDay = currentDay;
                }
            }
        }

        // If not open today or already past today's slots, look ahead
        if (!isOpen && !nextOpenTime) {
            const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            const currentDayIndex = daysOfWeek.indexOf(currentDay);

            for (let i = 1; i <= 7; i++) {
                const nextIndex = (currentDayIndex + i) % 7;
                const nextDay = daysOfWeek[nextIndex];
                const nextSchedule = businessHours.find(bh => bh.day.toLowerCase() === nextDay.toLowerCase());

                if (nextSchedule?.is_open && Array.isArray(nextSchedule.intervals) && nextSchedule.intervals.length > 0) {
                    const nextDate = now.add(i, 'day').format('YYYY-MM-DD');
                    const nextInterval = nextSchedule.intervals[0]; // First interval
                    const nextOpenDateTime = dayjs.tz(`${nextDate} ${nextInterval.open_time}`, 'YYYY-MM-DD HH:mm', vendorTimezone);
                    nextOpenTime = nextOpenDateTime.format('hh:mm A');
                    nextOpenDay = nextDay;
                    break;
                }
            }
        }

        return {
            status: isOpen ? 'open' : 'closed',
            nextOpenTime: isOpen ? null : nextOpenTime,
            nextOpenDay: isOpen ? null : nextOpenDay
        };

    } catch (error) {
        console.error('Error checking open status:', error);
        return { status: 'closed', nextOpenTime: null, nextOpenDay: null };
    }
}
